import { AndroidDependenciesReleaseReport, AndroidDependenciesReleaseResponse } from '@/types/androidDependencies';

export const TRY_FETCH_ANDROID_DEPENDENCIES_FOR_RELEASE = 'TRY_FETCH_ANDROID_DEPENDENCIES_FOR_RELEASE';
export const FETCH_ANDROID_DEPENDENCIES_FOR_RELEASE_SUCCESS = 'FETCH_ANDROID_DEPENDENCIES_FOR_RELEASE_SUCCESS';
export const UPDATE_ANDROID_DEPENDENCIES_FOR_RELEASE = 'UPDATE_ANDROID_DEPENDENCIES_FOR_RELEASE';
export const UPDATE_ANDROID_DEPENDENCIES_REPORT_FOR_RELEASE = 'UPDATE_ANDROID_DEPENDENCIES_REPORT_FOR_RELEASE';

export interface FetchAndroidDependenciesRequest {
    orgId: string;
    appId: string;
    releaseId: string;
}

export interface TryFetchAndroidDependenciesForReleaseAction {
    type: typeof TRY_FETCH_ANDROID_DEPENDENCIES_FOR_RELEASE;
    payload: FetchAndroidDependenciesRequest;
}

export interface FetchAndroidDependenciesForReleaseSuccessPayload {
    releaseId: string;
    response: AndroidDependenciesReleaseResponse;
}

export interface FetchAndroidDependenciesForReleaseSuccessAction {
    type: typeof FETCH_ANDROID_DEPENDENCIES_FOR_RELEASE_SUCCESS;
    payload: FetchAndroidDependenciesForReleaseSuccessPayload;
}

export interface UpdateAndroidDependenciesForReleaseAction {
    type: typeof UPDATE_ANDROID_DEPENDENCIES_FOR_RELEASE;
    payload: FetchAndroidDependenciesForReleaseSuccessPayload;
}

export interface UpdateAndroidDependenciesReportForReleasePayload {
    releaseId: string;
    report: AndroidDependenciesReleaseReport;
}

export interface UpdateAndroidDependenciesReportForReleaseAction {
    type: typeof UPDATE_ANDROID_DEPENDENCIES_REPORT_FOR_RELEASE;
    payload: UpdateAndroidDependenciesReportForReleasePayload;
}

export const tryFetchAndroidDependenciesForRelease = (
    payload: FetchAndroidDependenciesRequest,
): TryFetchAndroidDependenciesForReleaseAction => ({
    type: TRY_FETCH_ANDROID_DEPENDENCIES_FOR_RELEASE,
    payload,
});

export const fetchAndroidDependenciesForReleaseSuccess = (
    payload: FetchAndroidDependenciesForReleaseSuccessPayload,
): FetchAndroidDependenciesForReleaseSuccessAction => ({
    type: FETCH_ANDROID_DEPENDENCIES_FOR_RELEASE_SUCCESS,
    payload,
});

export const updateAndroidDependenciesForRelease = (
    payload: FetchAndroidDependenciesForReleaseSuccessPayload,
): UpdateAndroidDependenciesForReleaseAction => ({
    type: UPDATE_ANDROID_DEPENDENCIES_FOR_RELEASE,
    payload,
});

export const updateAndroidDependenciesReportForRelease = (
    payload: UpdateAndroidDependenciesReportForReleasePayload,
): UpdateAndroidDependenciesReportForReleaseAction => ({
    type: UPDATE_ANDROID_DEPENDENCIES_REPORT_FOR_RELEASE,
    payload,
});

export type AndroidDependenciesAction =
    | TryFetchAndroidDependenciesForReleaseAction
    | FetchAndroidDependenciesForReleaseSuccessAction
    | UpdateAndroidDependenciesForReleaseAction
    | UpdateAndroidDependenciesReportForReleaseAction;
